<div class="c-notification-center js-notification-center js-is-ready">
    <button (click)="toggleMenuNotifications()" class="c-notification-center__toggle notification-bell u-ml-none" aria-expanded="false">
        <span class="c-badge__wrapper  c-notification-center__toggle__badge" *ngIf="notifications > 0">
            <span class="c-badge  c-badge--notification  ">
                {{notifications}}
            </span>
        </span>
    </button>
    <app-notification-menu></app-notification-menu>
</div>